<template>
  <div>
    <QForm ref="form">
      <div class="q-mb-sm row">
        {{ contractDescription }}
      </div>
      <div class="row">
        <div class="col-9">
          <QInput
            v-model="monthlyCredits"
            dense
            filled
            :rules="monthlyCreditsRules"
            square
            type="number"
          />
        </div>
        <div class="col-3">
          <QToggle v-model="unlimited" />
          Unlimited
        </div>
      </div>
      <template v-if="showBlockInvoice">
        <div class="row">
          <div class="col-12">
            <QToggle v-model="blockInvoice" />
            Block Invoice
          </div>
        </div>
        <div
          v-if="modelValue.blockInvoice"
          class="row"
        >
          <div class="col-12">
            <p>Reason To Block Invoicing feature for SLA duration?</p>
            <QInput
              v-model="blockInvoiceReason"
              dense
              filled
              :rules="blockInvoiceReasonRules"
              square
              type="textarea"
            />
          </div>
        </div>
      </template>
    </QForm>
  </div>
</template>

<script>
import { organisationContractTypes } from "shared/constants";

import { useUserStore } from "src/stores/user";

export default {
  name: "OrganisationFeatureAllowanceForm",
  props: {
    modelValue: {
      type: Object,
      required: true,
    },
  },
  emits: ["update:modelValue"],
  setup() {
    const userStore = useUserStore();
    const { hasAccessLevel } = userStore;

    return { hasAccessLevel };
  },
  computed: {
    monthlyCredits: {
      get() {
        return this.modelValue.monthlyCredits;
      },
      set(value) {
        this.update("monthlyCredits", value);
      },
    },
    unlimited: {
      get() {
        return this.modelValue.unlimited;
      },
      set(value) {
        this.update("unlimited", value);
      },
    },
    blockInvoice: {
      get() {
        return this.modelValue.blockInvoice;
      },
      set(value) {
        this.update("blockInvoice", value);
      },
    },
    blockInvoiceReason: {
      get() {
        return this.modelValue.blockInvoiceReason;
      },
      set(value) {
        this.update("blockInvoiceReason", value);
      },
    },
    monthlyCreditsRules() {
      if (this.modelValue.unlimited) {
        return [() => true];
      }

      return [
        (val) => {
          if (val.length === 0) return "Monthly Credits cannot be blank";

          return true;
        },
      ];
    },
    blockInvoiceReasonRules() {
      if (!this.modelValue.blockInvoice) {
        return [() => true];
      }

      return [
        (val) => {
          if (!val || val.length === 0)
            return "Block Invoice Reason cannot be blank";

          return true;
        },
      ];
    },
    showBlockInvoice() {
      if (!this.hasAccessLevel("super")) return false;

      const { organisationContract } = this.modelValue;

      return organisationContract.isSLA();
    },
    contractDescription() {
      const { organisationContract } = this.modelValue;

      const contractType = this.contractType(organisationContract.contractType);

      return `${contractType.label} (Expires: ${organisationContract.contractExpiry})`;
    },
    form() {
      return this.$refs.form;
    },
  },
  methods: {
    /** @public */
    validate() {
      return this.form.validate();
    },
    update(key, value) {
      const organisationFeatureAllowance = this.modelValue;

      organisationFeatureAllowance[key] = value;
      delete organisationFeatureAllowance.isMarkedForDestruction;

      this.$emit("update:modelValue", organisationFeatureAllowance);
    },
    contractType(key) {
      return organisationContractTypes.find(
        (contractType) => contractType.id === key
      );
    },
  },
};
</script>
